<template>
    <fragment>
        <li class="menu-section">
            <h4 class="menu-text">Quản lý nhân sự</h4>
        </li>

        <!-- Khối cơ sở -->
        <MenuSubmenu
            v-if="hasPermission(permission.KHOI_CO_SO)"
            icon="fas fa-gopuram"
            text="Khối cơ sở"
            :items="baseBlockItems"
        />

        <!-- Trụ sở tổng -->
        <MenuSubmenu
            v-if="hasPermission(permission.TRU_SO_TONG)"
            icon="fas fa-building"
            text="Trụ sở tổng"
            :items="headquartersItems"
        />

        <!-- Website tuyển dụng -->
        <MenuLink
            v-if="hasPermission(permission.WEBSITE_TUYEN_DUNG)"
            :to="{ name: 'jobs-list' }"
            icon="fab fa-chrome"
            text="Website tuyển dụng"
        />

        <!-- Sự kiện nội bộ -->
        <MenuLink
            v-if="hasPermission(permission.SU_KIEN_NOI_BO)"
            :to="{ name: 'company-event-list' }"
            icon="fa fa-calendar-check"
            text="Sự kiện nội bộ"
        />
<!--        dau an-->
        <MenuLink
            :to="{ name: 'event-seating' }"
            icon="fas fa-users"
            text="Sự kiện dấu ấn"
        />

        <!-- Quản lý đơn vị hành chính -->
        <MenuSubmenu
            v-if="hasPermission(permission.QUAN_LY_DON_VI_HANH_CHINH)"
            icon="fas fa-chart-area"
            text="Quản lý đơn vị hành chính"
            :items="administrativeUnitItems"
        />

        <!-- Quản lý đào tạo -->
        <MenuSubmenu
            v-if="hasPermission(permission.QUAN_LY_DAO_TAO)"
            icon="fas fa-tag"
            text="Quản lý đào tạo"
            :items="trainingManagementItems"
        />

        <!-- Chương trình vinh danh -->
        <MenuLink
            v-if="hasPermission(permission.CHUONG_TRINH_VINH_DANH)"
            :to="{ name: 'honorsList' }"
            icon="fas fa-users"
            text="Chương trình vinh danh"
        />

        <!-- App game Cambridge -->
        <MenuLink
            v-if="hasPermission(permission.APP_GAME_CAMBRIDGE)"
            :to="{ name: 'SuperDashIndex' }"
            icon="fas fa-users"
            text="App game Cambridge"
        />
    </fragment>
</template>

<script>
import { mapGetters } from 'vuex'
import MenuLink from './MenuLink.vue'
import MenuSubmenu from './MenuSubmenu.vue'

export default {
    name: 'HRManagementMenu',

    components: {
        MenuLink,
        MenuSubmenu
    },

    computed: {
        ...mapGetters(['currentUser']),

        baseBlockItems() {
            return [
                {
                    text: 'Quản lý',
                    icon: 'menu-bullet-dot',
                    permission: this.permission.QUAN_LY_NHAN_SU_KHOI_CO_SO,
                    children: this.baseBlockManagementItems
                },
                {
                    text: 'Báo cáo',
                    icon: 'menu-bullet-dot',
                    permission: this.permission.BAO_CAO,
                    children: this.baseBlockReportItems
                }
            ]
        },

        baseBlockManagementItems() {
            return [
                {
                    name: 'user-index',
                    text: 'DS nhân sự',
                    permission: this.permission.DANH_SACH_NHAN_SU
                },
                {
                    name: 'sale-tree-view',
                    text: 'Phân cấp sales',
                    permission: this.permission.XEM_DANH_SACH_NHAN_SU_CO_SO
                },
                {
                    name: 'move-branch',
                    text: 'Điều chuyển nhân sự',
                    permission: this.permission.DIEU_CHUYEN_NHAN_SU
                },
                {
                    name: 'log-resource-list',
                    text: 'Phiếu lương',
                    permission: this.permission.PHIEU_LUONG
                },
                {
                    name: 'sale-promotion',
                    text: 'Sale lên cấp',
                    permission: this.permission.SALE_LEN_CAP
                },
                {
                    name: 'sale-degradation',
                    text: 'Sale xuống cấp',
                    permission: this.permission.SALE_XUONG_CAP
                },
                {
                    name: 'amount-log-list',
                    text: 'Danh sách đóng tiền',
                    permission: this.permission.XEM_DANH_SACH_DONG_TIEN
                },
                {
                    name: 'user-candidate',
                    text: 'Ứng viên',
                    permission: this.permission.UNG_VIEN
                },
                {
                    name: 'BondManagementList',
                    text: 'Trái phiếu',
                    permission: this.permission.TRAI_PHIEU
                },
                {
                    name: 'list-propose-application',
                    text: 'Duyệt đề xuất',
                    permission: this.permission.DUYET_DON
                },
                {
                    name: 'list-kpi-van-phong',
                    text: 'Upload KPI',
                    permission: this.permission.TRAI_PHIEU
                },
                {
                  name: 'setup-salary-mechanism',
                  text: 'Cấu hình cơ chế lương',
                  permission: this.permission.QUAN_LY_CO_CHE_LUONG
                }
            ]
        },

        baseBlockReportItems() {
            return [
                {
                    name: 'employee',
                    text: 'Biến động nhân sự',
                    permission: null
                },
                {
                    name: 'sale-time-keep',
                    text: 'Chấm công sale',
                    permission: null
                }
            ]
        },

        headquartersItems() {
            return [
                {
                    text: 'Quản lý',
                    icon: 'menu-bullet-dot',
                    permission: this.permission.QUAN_LY_NHAN_SU_TRU_SO_TONG,
                    children: this.headquartersManagementItems
                }
            ]
        },

        headquartersManagementItems() {
            return [
                {
                    name: 'list-role-department',
                    text: 'Quản lý đơn vị',
                    permission: this.permission.QUAN_LY_DON_VI_TRU_SO_TONG
                },
                {
                    name: 'attendance-index',
                    text: 'Nhân sự chấm công',
                    permission: this.permission.NHAN_SU_CHAM_CONG
                },
                {
                    name: 'timekeeping-list',
                    text: 'Quản lý chấm công',
                    permission: this.permission.QUAN_LY_CHAM_CONG
                },
                {
                    name: 'list-propose-application',
                    text: 'Đơn đề xuất',
                    permission: this.permission.DON_DE_XUAT
                },
                {
                    name: 'ListManagementKpi',
                    text: 'Quản lý KPI nhân sự',
                    permission: this.permission.QUAN_LY_KPI_NHAN_SU
                },
                {
                    name: 'ManageOkrList',
                    text: 'Quản lý OKRs',
                    permission: this.permission.QUAN_LY_DON_VI_TRU_SO_TONG
                },
                {
                    name: 'ManageKraList',
                    text: 'Quản lý KRAs',
                    permission: this.permission.QUAN_LY_DON_VI_TRU_SO_TONG
                },
                {
                    name: 'ManageTeamLeadIndex',
                    text: 'Quản lý chỉ số team lead',
                    permission: this.permission.QUAN_LY_DON_VI_TRU_SO_TONG
                },
                {
                    name: 'ManageMinusPoint',
                    text: 'Quản lý điểm trừ',
                    permission: this.permission.QUAN_LY_DON_VI_TRU_SO_TONG
                },
                {
                    name: 'approve-level',
                    text: 'Duyệt level nhân sự',
                    permission: this.permission.DUYET_LEVEL_NHAN_SU
                },
                {
                    name: 'level-employees',
                    text: 'Bảng tiêu chuẩn chỉ số',
                    permission: this.permission.DUYET_LEVEL_NHAN_SU
                },
                {
                    name: 'user-level-list',
                    text: 'Danh sách level',
                    permission: this.permission.DUYET_LEVEL_NHAN_SU
                },
                {
                    name: 'category-level',
                    text: 'Danh mục level',
                    permission: this.permission.DUYET_LEVEL_NHAN_SU
                }
            ]
        },

        administrativeUnitItems() {
            return [
                {
                    name: 'area-index',
                    text: 'Khu vực',
                    permission: null
                },
                {
                    name: 'office-index',
                    text: 'Quản lý tên văn phòng',
                    permission: null
                },
                {
                    name: 'RegionIndex',
                    text: 'Quản lý vùng',
                    permission: null
                }
            ]
        },

        trainingManagementItems() {
            return [
                {
                    name: 'policy-manage',
                    text: 'Phân quyền chương trình',
                    permission: this.permission.PHAN_QUYEN_CHUONG_TRINH
                },
                {
                    name: 'manage-candidate-teacher',
                    text: 'Gia nhập giảng viên',
                    permission: this.permission.QUAN_LY_DAO_TAO_UNG_VIEN_GIANG_VIEN
                },
                {
                    name: 'training-manage',
                    text: 'Chương trình TVV định kỳ',
                    permission: this.permission.CHUONG_TRINH_TVV_DINH_KY
                },
                {
                    name: 'trainning-report',
                    text: 'Báo cáo đào tạo',
                    permission: this.permission.BAO_CAO_DAO_TAO
                },
                {
                    name: 'gen-z',
                    text: 'Web Genz',
                    permission: this.permission.WEB_GENZ
                }
            ]
        }
    },

    methods: {
        hasPermission(permission) {
            return this.currentUser?.user?.permission?.includes(permission)
        }
    }
}
</script>
